import actions from './campaign.actions'
import mutations from './campaign.mutations'
import state from './campaign.state'
import getters from './campaign.getters'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
